import ApiService from './api.service'

const ProjectService = {    
    get(typePublicCode, companyId, groupId, withoutGroup, name, isDeleted, page, count) {
        return ApiService.get('api/projects', {
            params: {
              TypePublicCode: typePublicCode,
              CompanyId: companyId,
              GroupId: groupId,
              WithoutGroup: withoutGroup,
              Name: name,
              IsDeleted: isDeleted,
              Page: page,
              Count: count
            }
        })
    },

    getTransports(projectId, sortColumns) {
        return ApiService.get('api/projects/transports', {
            params: {
              ProjectId: projectId,
              SortColumns: sortColumns              
            }
        })
    },

    getMeters(projectId, energyMeterTypePublicCode, sortColumns) {
        return ApiService.get('api/projects/meters', {
            params: {
              ProjectId: projectId,
              EnergyMeterTypePublicCode: energyMeterTypePublicCode,
              SortColumns: sortColumns              
            }
        })
    },

    getNodes(projectId,  sortColumns) {
        return ApiService.get('api/projects/nodes', {
            params: {
              ProjectId: projectId,
              SortColumns: sortColumns              
            }
        })
    },

    getById(id) {
      return ApiService.get('api/projects/'+id)
    },

    create(idGroup, idType, name, additionalInfo) {
      let project = {
        idGroup: idGroup,
        idType: idType,
        name: name,
        additionalInfo: additionalInfo
      }
      return ApiService.post(`/api/projects`, project)
    },

    update(id, idGroup, name, additionalInfo) {
      let project = {
        id: id,
        idGroup: idGroup,
        name: name,
        additionalInfo: additionalInfo
      }
      return ApiService.put(`/api/projects`, project)
    },

    updateUserMapLayer(id, userMapLayer) {
      let project = {
        id: id,
        userMapLayer: userMapLayer,
      }
      return ApiService.put(`/api/projects/map-layer`, project)
    },

    archive(id) {
      return ApiService.put(`/api/projects/archive/${id}`)
    },

    restore(id) {
      return ApiService.put(`/api/projects/restore/${id}`)
    },

    delete(id) {
      return ApiService.delete(`/api/projects/${id}`)
    },
    
    createGroup(name) {
      let project = {
        name: name
      }
      return ApiService.post(`/api/projects/groups`, project)
    },

    updateGroup(id, name) {
      let project = {
        id: id,
        name: name
      }
      return ApiService.put(`/api/projects/groups`, project)
    },

    deleteGroup(id) {
      return ApiService.delete(`/api/projects/groups/${id}`)
    },

    addNode(idCompany, idProject, idNode) {
      let project = {
        idCompany: idCompany,
        idProject: idProject,
        idNode: idNode
      }
      return ApiService.put(`/api/projects/add-node`, project)
    },

    addMeter(idCompany, idProject, idMeter, role) {
      let project = {
        idCompany: idCompany,
        idProject: idProject,
        idMeter: idMeter,
        role: role
      }
      return ApiService.put(`/api/projects/add-meter`, project)
    },

    removeNode(idCompany, idProject, idNode) {
      let project = {
        idCompany: idCompany,
        idProject: idProject,
        idNode: idNode
      }
      return ApiService.put(`/api/projects/remove-node`, project)
    },

    removeMeter(idCompany, idProject, idMeter) {
      let project = {
        idCompany: idCompany,
        idProject: idProject,
        idMeter: idMeter
      }
      return ApiService.put(`/api/projects/remove-meter`, project)
    },

    getGroups(id) {
      return ApiService.get('api/projects/groups', {
        params: {
            Id: id
        }
      })
    },

    getFeatures(id, projectTypePublicCode, notInIdProject) {
      return ApiService.get('api/projects/features', {
        params: {
            Id: id,
            ProjectTypePublicCode: projectTypePublicCode,
            NotInIdProject: notInIdProject
        }
      })
    },

    getProjectFeatures(projectId) {       
      return ApiService.get('api/projects/project-features', {
        params: {
          ProjectId: projectId
        }
      })
    },

    addFeature(idCompany, idProject, idFeature) {
      let project = {
        idCompany: idCompany, 
        idProject: idProject,
        idFeature: idFeature
      }
      return ApiService.put(`/api/projects/add-feature`, project)
    },

    updateFeature(idProjectFeature, settings) {
      let feature = {
        idProjectFeature: idProjectFeature,
        settings: settings
      }
      return ApiService.put(`/api/projects/update-feature`, feature)
    },

    removeFeature(idCompany, idProject, idFeature) {
      let project = {
        idCompany: idCompany,
        idProject: idProject,
        idFeature: idFeature
      }
      return ApiService.put(`/api/projects/remove-feature`, project)
    },

    getTypes(id) {
      return ApiService.get('api/projects/types', {
        params: {
            Id: id
        }
      })
    },
}

export default ProjectService